import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/completed.png'
import _imports_1 from '@/assets/images/not_completed.png'


const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "animate__animated animate__bounceIn",
  src: _imports_0,
  alt: "済"
}
const _hoisted_3 = {
  key: 1,
  class: "animate__animated animate__bounceIn",
  src: _imports_1,
  alt: "未済"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "w-6 sm:w-7",
    disabled: _ctx.btnDisabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.watchCompletionSwitch()))
  }, [
    (_ctx.isCompleted)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3))
  ], 8, _hoisted_1))
}